<template>
  <v-container>
    <v-snackbar
      v-model="snackbar"
      xs12
      multi-line
      :timeout="timeout"
      top
      color="orange"
    >
      {{ alertmessage }}
      <v-btn
        color="white"
        text
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
    <v-row>
      <v-col>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          color="primary"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <base-material-card
          v-if="!loading"
          color="primary"
          icon="mdi-bank"
          inline
        >
          <template v-slot:after-heading>
            <div class="display-2 font-weight-light">
              Institution Management
            </div>
          </template>
          <v-col cols="12">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            />
          </v-col>
          <v-row>
            <v-col
              sm="12"
            >
              <v-card
                class="pa-2"
                outlined
                tile
              >
                <v-toolbar
                  flat
                  color="white"
                >
                  <v-dialog v-model="dialog">
                    <v-card>
                      <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                      </v-card-title>
                      <v-card-text>
                        <v-row>
                          <v-col
                            cols="12"
                            sm="6"
                            md="4"
                          >
                            <v-text-field
                              v-model="editedItem.name"
                              disabled
                              label="Instiution Name"
                            />
                          </v-col>
                          <v-col
                            cols="12"
                            sm="6"
                            md="4"
                          >
                            <v-text-field
                              v-model="editedItem.key"
                              disabled
                              label="Instiution Key"
                            />
                            {{ editedItem.numsites }}
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-col cols="12">
                        <v-text-field
                          v-model="searchSites"
                          append-icon="mdi-magnify"
                          label="Search"
                          single-line
                          hide-details
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        class="ma-2 pa-2"
                      >
                        <v-data-table
                          v-model="selectedSites"
                          :headers="headerSites"
                          :search="searchSites"
                          :items="getcurrentSites"
                          :single-select="singleSelect"
                          show-select
                          item-key="sitekey"
                          class="elevation-1"
                        />
                      </v-col>

                      <v-card-actions>
                        <v-spacer />
                        <v-btn
                          color="blue darken-1"
                          @click="close"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          color="blue darken-1"
                          @click="save"
                        >
                          Save
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <v-spacer />
                </v-toolbar>
                <v-data-table
                  :headers="headers"
                  :search="search"
                  :items="getcurrentinst"
                  item-key="key"
                  class="elevation-1"
                >
                  <template
                    v-if="userallowed"
                    v-slot:[`item.action`]="{ item }"
                  >
                    <v-icon

                      color="primary"
                      size="20"
                      @click="editItem(item)"
                    >
                      mdi-square-edit-outline
                    </v-icon>
                  </template>
                  <template v-slot:no-data>
                    <v-btn color="primary">
                      Reset
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </base-material-card>

        <v-spacer />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  // Components

  export default {
    data: () => ({
      search: '',
      searchSites: '',
      selectedSites: [],
      singleSelect: false,
      dialog: false,
      time: null,
      newgroup: '',
      snackbar: false,
      singleExpand: true,
      expanded: [],
      timeout: 5000,
      alertmessage: '',
      headers_change: [
        { text: 'Label', align: 'left', value: 'label', sortable: false },
        { text: 'Group', align: 'left', value: 'group', sortable: false },
      ],
      headerSites: [
        { text: 'Site Name', align: 'left', value: 'idnum', sortable: false },
        { text: 'Group', align: 'left', value: 'group', sortable: true },
        { text: 'State', align: 'left', value: 'state', sortable: true },
        { text: 'Selected', align: 'left', value: 'instselected', sortable: true },
      ],
      externalsafe: false,
      menu2: false,
      menu3: false,
      menu4: false,
      menu5: false,
      modal2: false,
      loading: false,
      headers: [
        { text: 'Institution Name', value: 'name', align: 'left', width: 200 },
        { text: 'Institution Key', value: 'key', align: 'center' },
        { text: 'Total Sites', value: 'numsites', align: 'center' },
        { text: 'Actions', value: 'action', sortable: false }
      ],
      sites: [],
      editedIndex: -1,
      editedItem: {
        name: '',
        sitekeys: [],
        key: '',
      },
      defaultItem: {
        name: '',
        sitekeys: [],
        key: '',
      }
    }),

    computed: {
      getcurrentgroups () {
        this.$log.debug('groups', this.$store.getters.usergroups)
        this.currentgroups = this.$store.getters.usergroups
        return this.currentgroups
      },
      grouplist () {
        // return []
        let groups = this.$store.getters.usergroups.map(
          group => group.name
        )
        return groups
      },
      userallowed () {
        if (parseInt(this.$store.getters.user.level) >= 500 || this.$store.getters.user.status === 'corporate') {
          this.$log.debug('user allowed', this.$store.getters.user.level)

          return true
        }
        this.$log.debug('user NOT allowed', this.$store.getters.user.level)

        return false
      },
      formTitle () {
        return this.editedIndex === -1 ? 'New Site' : 'Edit Institution'
      },
      getcurrentinst () {
        this.currentInst = []
        this.currentInst = this.$store.getters.userinstitutions
        let numsites = 0
        this.currentInst.forEach(item => {
          if (item.sitekeys) {
            numsites = item.sitekeys.length
            Object.assign(item, { numsites: numsites })
          } else {
            console.log(item, ' has no assigned sites ')
            numsites = 'NA'
            Object.assign(item, { numsites: numsites })
          }
        })
        return this.currentInst
      },
      getcurrentSites () {
        let currentsites = []
        currentsites = this.sites

        return this.sites
      },
      currentmachines () {

      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      loading (val) {
        if (!val) return

        setTimeout(() => (this.loading = false), 1000)
      }
    },
    created () {
      this.loading = true
      this.$store.dispatch('loadunits')
      this.$store.dispatch('loadsiteProfiles')
      this.$store.dispatch('loadSiteConfigs')
      this.$store.dispatch('loadUserInstitutions')

      // inject all rimi sites for testing
      this.sites = this.$store.getters.loadedSites
    },

    methods: {
      resetSelected () {

      },
      userlist (group) {
        this.$log.debug('%%%%% group passed is ', group)
        let people = this.$store.getters.userprofiles
        this.$log.debug('people rec is ', people)
        let usersfromgroup = people.filter(person => person.group === group)
        return usersfromgroup.map(usr => usr.email)
      },
      removeGroup (index) {
        let numelements = 1
        let grp = this.currentgroups[index]
        this.currentgroups.splice(index, numelements)
        this.$store.dispatch('removeUserGroup', grp)
        this.$store.dispatch('loadUserGroups')
      },
      editItem (item) {
        this.selectedSites = []
        // set the items selected sites
        if (item.sitekeys) {
          item.sitekeys.forEach(key => {
            // loop thru the sites for a key match
            this.sites.forEach(site => {
              if (site.sitekey === key) {
                Object.assign(site, { instselected: 'true' })
                this.selectedSites.push(site)
              }
            })
          })
        }
        // console.log('!!!!! our item should be ', item, item.length, this.selectedSites)

        this.editedIndex = this.currentInst.indexOf(item)

        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        const index = this.sites.indexOf(item)
        this.$log.debug('site info is ', item)
        if (confirm('Are you sure you want to delete this item?') && this.sites.splice(index, 1)) {
          this.$log.debug('site info is ', item)
          this.$store.dispatch('loadunits')
          this.$store.dispatch('loadsiteProfiles')
          this.$store.dispatch('loadUserGroups')
          this.$store.dispatch('loadSiteConfigs')
          this.$store.dispatch('removeSite', item)
        }
      },

      close () {
        this.dialog = false
        //
        this.selectedSites = []
        this.searchSites = ''
        this.sites.forEach(item => {
          Object.assign(item, { instselected: '' })
        })
        // reset selected sites here
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        this.dialog = false
        if (this.editedIndex > -1) {
          const instData = {
            name: this.editedItem.name,
            key: this.editedItem.key,
            sitekeys: this.selectedSites.map(entry => entry.sitekey)
          }
          // they already exist so we only update them with new data
          this.$store.dispatch('updateInstitutions', instData)
          this.$store.dispatch('loadUserInstitutions')
        }
        this.sites = this.$store.getters.loadedSites
        this.searchSites = ''
        this.selectedSites = []
        this.sites.forEach(item => {
          Object.assign(item, { instselected: '' })
        })
      }
    }
  }
</script>
<style>
  .card--flex-toolbar {
    margin-top: -64px;
  }
</style>
